'use client';

import { motion } from 'framer-motion';

export function GeometricBackground() {
    return (
        <div className="absolute inset-0 overflow-hidden pointer-events-none z-0 bg-black">
            {/* Abstract dark gradient base */}
            <div className="absolute top-0 right-0 w-[80vw] h-[80vh] bg-[radial-gradient(ellipse_at_top_right,rgba(0,102,255,0.15),transparent_50%)]" />
            <div className="absolute bottom-0 left-0 w-[60vw] h-[60vh] bg-[radial-gradient(ellipse_at_bottom_left,rgba(0,64,255,0.1),transparent_50%)]" />

            {/* High-tech sharp grid */}
            <div
                className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff05_1px,transparent_1px),linear-gradient(to_bottom,#ffffff05_1px,transparent_1px)] bg-[size:64px_64px]"
                style={{ maskImage: 'linear-gradient(to bottom, black 40%, transparent 100%)' }}
            />

            {/* Moving geometric shapes — GPU composited with will-change */}
            <motion.div
                className="absolute top-[10%] right-[15%] w-96 h-96 border-[1px] border-white/5 rotate-45"
                animate={{
                    rotate: [45, 90, 45],
                }}
                transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
                style={{ willChange: 'transform' }}
            />
            <motion.div
                className="absolute top-[20%] right-[5%] w-64 h-64 border-[1px] border-primary/20 rounded-full"
                animate={{
                    y: [0, -30, 0],
                    x: [0, 20, 0],
                }}
                transition={{ duration: 15, repeat: Infinity, ease: "easeInOut" }}
                style={{ willChange: 'transform' }}
            />
        </div>
    );
}

